// Todoboxx — scripts propios (mt-*)
// Varias secciones cargan este archivo: solo se inicializa una vez.
if (!window.__mtScriptsListo) {
  window.__mtScriptsListo = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initGaleria();
    initVariantes();
    initFaq();
    initBuscador();
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleria() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var thumbs = galeria.querySelectorAll('[data-mt-thumb]');
    var principales = galeria.querySelectorAll('[data-mt-principal]');
    if (!thumbs.length || !principales.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-mt-thumb');
        thumbs.forEach(function (t) { t.classList.remove('mt-activo'); });
        thumb.classList.add('mt-activo');
        principales.forEach(function (img) {
          img.classList.toggle('mt-activa', img.getAttribute('data-mt-principal') === idx);
        });
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-mt-add-btn]');
    var precioEl = form.querySelector('[data-mt-precio-actual]');
    var precioAnteriorEl = form.querySelector('[data-mt-precio-anterior]');
    var pills = form.querySelectorAll('[data-mt-opcion-pill]');

    function seleccionActual() {
      var seleccion = {};
      form.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
        var activo = grupo.querySelector('.mt-seleccionado');
        if (activo) seleccion[grupo.getAttribute('data-mt-opcion')] = activo.getAttribute('data-valor');
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = seleccionActual();
      return variantes.find(function (v) {
        return v.options.every(function (val, i) { return val === seleccion[i]; });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = variante.price_fmt || formatoDinero(variante.price);
      if (precioAnteriorEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnteriorEl.textContent = variante.compare_fmt || formatoDinero(variante.compare_at_price);
          precioAnteriorEl.style.display = '';
        } else {
          precioAnteriorEl.style.display = 'none';
        }
      }
      aplicarFotos(variante);
      if (addBtn) {
        addBtn.disabled = !variante.available;
        addBtn.textContent = variante.available ? addBtn.getAttribute('data-texto-disponible') : addBtn.getAttribute('data-texto-agotado');
      }
    }

    // Muestra solo las fotos propias de la variante elegida (si tiene lista); si no, toda la galería.
    var ultimaLista = '';
    function aplicarFotos(v) {
      var thumbs = document.querySelectorAll('[data-mt-thumb]');
      var lista = (v.fotos && v.fotos.length) ? v.fotos : null;
      var clave = lista ? lista.join(',') : 'todas:' + v.media_pos;
      if (clave === ultimaLista) return;
      ultimaLista = clave;
      var visibles = {};
      if (lista) lista.forEach(function (n) { visibles[n - 1] = true; });
      thumbs.forEach(function (t) { t.style.display = (!lista || visibles[t.getAttribute('data-mt-thumb')]) ? '' : 'none'; });
      var primera = lista ? lista[0] - 1 : v.media_pos;
      if (primera >= 0) {
        var th = document.querySelector('[data-mt-thumb="' + primera + '"]');
        if (th) th.click();
      }
    }

    function formatoDinero(centavos) {
      return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(centavos, window.mtMoneyFormat) : '$' + (centavos / 100).toFixed(2);
    }

    // Marca (tachadas) las opciones que no existen junto con lo que ya está elegido.
    function marcarNoExiste() {
      var seleccion = seleccionActual();
      form.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
        var idx = grupo.getAttribute('data-mt-opcion');
        grupo.querySelectorAll('[data-mt-opcion-pill]').forEach(function (p) {
          var valor = p.getAttribute('data-valor');
          var existe = variantes.some(function (v) {
            return v.options[idx] === valor && v.options.every(function (o, i) { return String(i) === idx || o === seleccion[i]; });
          });
          p.classList.toggle('mt-no-existe', !existe);
        });
      });
    }

    // Si la combinación elegida no existe, se pasa a la variante más parecida que sí existe.
    function ajustarSeleccion(grupo, valor) {
      if (encontrarVariante()) return;
      var idx = grupo.getAttribute('data-mt-opcion');
      var seleccion = seleccionActual(), mejor = null, mejorPuntos = -1;
      variantes.forEach(function (v) {
        if (v.options[idx] !== valor) return;
        var puntos = v.options.reduce(function (a, o, i) { return a + (o === seleccion[i] ? 1 : 0); }, 0);
        if (puntos > mejorPuntos) { mejorPuntos = puntos; mejor = v; }
      });
      if (!mejor) return;
      form.querySelectorAll('[data-mt-opcion]').forEach(function (g) {
        var i = g.getAttribute('data-mt-opcion');
        g.querySelectorAll('[data-mt-opcion-pill]').forEach(function (p) {
          p.classList.toggle('mt-seleccionado', p.getAttribute('data-valor') === mejor.options[i]);
        });
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.classList.contains('mt-agotado-total')) return;
        var grupo = pill.closest('[data-mt-opcion]');
        grupo.querySelectorAll('[data-mt-opcion-pill]').forEach(function (p) { p.classList.remove('mt-seleccionado'); });
        pill.classList.add('mt-seleccionado');
        ajustarSeleccion(grupo, pill.getAttribute('data-valor'));
        actualizar();
        marcarNoExiste();
      });
    });

    actualizar();
    marcarNoExiste();
  });
}

function initFaq() {
  document.querySelectorAll('.mt-faq-item').forEach(function (item) {
    var boton = item.querySelector('.mt-faq-pregunta');
    var respuesta = item.querySelector('.mt-faq-respuesta');
    if (!boton || !respuesta) return;
    boton.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-abierto');
      item.closest('.mt-faq-lista').querySelectorAll('.mt-faq-item').forEach(function (otro) {
        otro.classList.remove('mt-abierto');
        otro.querySelector('.mt-faq-respuesta').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('mt-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}


function initBuscador() {
  document.querySelectorAll('[data-mt-buscador]').forEach(function (root) {
    var dataEl = root.querySelector('[data-mt-catalogo]');
    var selMarca = root.querySelector('[data-mt-marca]');
    var selModelo = root.querySelector('[data-mt-modelo]');
    var out = root.querySelector('[data-mt-resultados]');
    var sin = root.querySelector('[data-mt-sin-resultados]');
    if (!dataEl || !selMarca || !selModelo || !out) return;
    var catalogo;
    try { catalogo = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var vacio = out.innerHTML;
    var placeholder = selModelo.options[0] ? selModelo.options[0].textContent : '';

    function esDeMarca(p, marca) {
      var m = marca.toLowerCase();
      if (p.t.toLowerCase().indexOf(m) > -1) return true;
      return (p.tags || []).some(function (t) { return t.toLowerCase() === m; });
    }
    function tokens(texto, marca) {
      var re = new RegExp('^' + marca.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s+', 'i');
      return String(texto).split(/\s*(?:\/|\s-\s|\sy\s|,)\s*/i).map(function (t) {
        return t.replace(re, '').trim();
      }).filter(Boolean);
    }
    function num(t) { var m = t.match(/\d+/); return m ? parseInt(m[0], 10) : 9999; }

    var marcas = (root.getAttribute('data-marcas') || '').split('|').map(function (m) { return m.trim(); }).filter(Boolean)
      .filter(function (marca) { return catalogo.some(function (p) { return esDeMarca(p, marca); }); });
    marcas.forEach(function (m) {
      var o = document.createElement('option'); o.value = m; o.textContent = m; selMarca.appendChild(o);
    });
    if (!marcas.length) return;

    function cargarModelos() {
      var marca = selMarca.value, vistos = {}, lista = [];
      catalogo.forEach(function (p) {
        if (!esDeMarca(p, marca)) return;
        p.vs.forEach(function (v) {
          if (!v.a) return;
          tokens(v.m, marca).forEach(function (t) {
            var k = t.toLowerCase();
            if (!vistos[k]) { vistos[k] = true; lista.push({ k: k, t: t }); }
          });
        });
      });
      lista.sort(function (a, b) { return num(a.t) - num(b.t) || a.t.localeCompare(b.t); });
      selModelo.innerHTML = '';
      var ph = document.createElement('option'); ph.value = ''; ph.textContent = placeholder; selModelo.appendChild(ph);
      lista.forEach(function (it) {
        var o = document.createElement('option'); o.value = it.k;
        o.textContent = (marca.toLowerCase() === 'iphone' ? 'iPhone ' : '') + it.t.charAt(0).toUpperCase() + it.t.slice(1);
        selModelo.appendChild(o);
      });
      selModelo.disabled = !lista.length;
      mostrar();
    }

    function mostrar() {
      var marca = selMarca.value, modelo = selModelo.value;
      out.innerHTML = '';
      if (sin) sin.hidden = true;
      if (!modelo) { out.innerHTML = vacio; return; }
      var hallados = 0;
      catalogo.forEach(function (p) {
        if (!esDeMarca(p, marca)) return;
        var coinc = p.vs.filter(function (v) { return v.a && tokens(v.m, marca).some(function (t) { return t.toLowerCase() === modelo; }); });
        if (!coinc.length) return;
        hallados++;
        var card = document.createElement('div'); card.className = 'mt-res-card';
        var a = document.createElement('a'); a.className = 'mt-res-img'; a.href = p.u + '?variant=' + coinc[0].id;
        if (p.img) { var im = document.createElement('img'); im.src = p.img; im.alt = ''; im.loading = 'lazy'; a.appendChild(im); }
        var cuerpo = document.createElement('div'); cuerpo.className = 'mt-res-cuerpo';
        var t = document.createElement('a'); t.className = 'mt-res-titulo'; t.href = a.href; t.textContent = p.t;
        var chips = document.createElement('div'); chips.className = 'mt-res-chips';
        var lista = coinc.length > 4 ? [coinc[0]] : coinc;
        lista.forEach(function (v) {
          var c = document.createElement('a'); c.className = 'mt-chip'; c.href = p.u + '?variant=' + v.id;
          if (coinc.length > 4) {
            c.appendChild(document.createTextNode('Ver ' + coinc.length + ' opciones · ' + v.p));
            chips.appendChild(c);
            return;
          }
          var etiqueta = String(v.x || '').replace(/[\s·]+$/, '').replace(/^[\s·]+/, '');
          c.appendChild(document.createTextNode((etiqueta ? etiqueta + ' · ' : '') + v.p));
          if (v.c) { var s = document.createElement('s'); s.textContent = v.c; c.appendChild(s); }
          chips.appendChild(c);
        });
        cuerpo.appendChild(t); cuerpo.appendChild(chips);
        card.appendChild(a); card.appendChild(cuerpo); out.appendChild(card);
      });
      if (!hallados && sin) sin.hidden = false;
    }

    selMarca.addEventListener('change', cargarModelos);
    selModelo.addEventListener('change', mostrar);
    cargarModelos();
  });
}
